import React from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    fontSize: "20px",
    fontWeight: 400,
    marginBottom: 0,
    [theme.breakpoints.down("xs")]: {
      fontSize: 16,
    },
  },
}));

const PageTitle = props => {
  const classes = useStyles();

  return (
    <Typography
      variant="h1"
      component="h2"
      gutterBottom
      className={classes.root}
    >
      {props.title}
    </Typography>
  );
};

export default PageTitle;
